{
  "version": 1,
  "asset_id": "65f20a71-c3b2-4148-928b-39fbf58e19b9",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/65f20a71-c3b2-4148-928b-39fbf58e19b9/homosassa-blue-metal-roof-installation-768w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/65f20a71-c3b2-4148-928b-39fbf58e19b9/homosassa-blue-metal-roof-installation-768w.avif",
  "original_filename": "homosassa-blue-metal-roof-installation-768w.avif",
  "size": 27200,
  "content_type": "image/avif",
  "created_at": "2026-07-21T19:37:41Z"
}
